import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { CommitHistoryTab } from "../../../components/commitHistoryTab";
import { ProgramDescriptionTab } from "./programDescriptionTab";
import { ParameterTab } from "./parameterTab";
import defaultAxios from 'axios';
import { FaLink } from "react-icons/fa";
import { TestTab } from "./testTab";
import { useAuth } from "../../../AuthContext";
import { backendUrl } from "../../../common/constantVarialble";
import { TbBrandOpenai } from "react-icons/tb";
import CodeEditor from '@uiw/react-textarea-code-editor';

interface SqlResponse {
    input_date: string;
    input_psn: string;
    last_update_dte: string | null;
    last_update_psn: string | null;
    prg_description: string;
    program_id: string;
    sql: string;
}

interface PrmInfo {
    param_name?: string;
    param_seq?: string;
}

interface PrgHstInfo {
    program_id: string;
    seq: string; // 소스 버전
    sql: string;
    commit_msg: string;
    update_date: string;
    update_psn: string;
    current_seq: string; // 적용 버전
}

const getSqlAndProgramDescription = async (program_id: string) => {
    try {
        const { data } = await defaultAxios({
            method: "post",
            //url: "http://localhost:5000/api/request/",
            url: backendUrl,
            data: {
                program_id: "PERCENT-ADMIN-PRG-L-LSTSQLBYPROGRAMID",
                params: {
                    program_id: program_id,
                },
                page_index: -1,
            },
        });
        return data;

    } catch (error) {
        console.error(error);
        return null;
    }
}

const getParameters = async (program_id: string) => {
    try {
        const { data } = await defaultAxios({
            method: "post",
            //url: "http://localhost:5000/api/request/",
            url: backendUrl,
            data: {
                program_id: "PERCENT-ADMIN-PRG-L-LSPARAMSBYPROGRAMID",
                params: {
                    program_id: program_id,
                },
                page_index: -1,
            },
        });
        return data;

    } catch (error) {
        console.error(error);
        return null;
    }
}

const getCommitHistory = async (program_id: string) => {
    try {
        const { data } = await defaultAxios({
            method: "post",
            //url: "http://localhost:5000/api/request/",
            url: backendUrl,
            data: {
                program_id: "PERCENT-ADMIN-PRG-L-LSTPRGHST",
                params: {
                    program_id: program_id,
                },
                page_index: -1,
            },
        });
        return data;

    } catch (error) {
        console.error(error);
        return null;
    }
}


function ProgramDetailPage() {
    const { userName } = useAuth();
    const [SQLState, setSQLState] = useState<SqlResponse | null>(null);
    const PARAMETER = "parameter";
    const HISTORY = "history";
    const DESCRIPTION = "description";
    const TEST = "test";

    const [programDetailMenu, setProgramDetailMenu] = useState(PARAMETER);
    const [prmInfo, setPrmInfo] = useState<PrmInfo[]>([]);
    const [commitMsg, setCommitMsg] = useState("");

    // test result
    const [testResult, setTestResult] = useState("percent/test/result>");

    // commit history
    const [prgHstInfo, setPrgHstInfo] = useState<PrgHstInfo[]>([]);
    const [selectedSeq, setSelectedSeq] = useState("");
    const [curretnSeq, setCurrentSeq] = useState("");

    // sql
    const [sql, setSQL] = useState("");

    // original sql - 수정하기 이전 화면의 sql
    const [originalSQL, setOriginalSQL] = useState("");

    // Parse the program_id from the URL parameters
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const program_id = searchParams.get("program_id");
    const navigate = useNavigate();


    const [trigger, setTrigger] = useState(0);

    const refreshProgramDetailPage = () => {
        setTrigger(Date.now());
    };


    useEffect(() => {
        console.log("data");
        const fetchSQLAndDescription = async () => {
            try {
                const data: any = await getSqlAndProgramDescription(program_id || "");
                console.log("Fetched data:", data);

                if (data) {
                    console.log("fetchData", data.data[0]);
                    setSQLState(data.data[0]);
                    setSQL(data.data[0].sql);
                    setOriginalSQL(data.data[0].sql);
                } else {
                    console.log("Data is null or undefined.");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        const fetchParameter = async () => {
            try {
                const data: any = await getParameters(program_id || "");
                console.log("Fetched parameter data:");
                console.log(data);

                if (data) {
                    console.log("fetchData parameter", data.data);
                    setPrmInfo(data.data);
                } else {
                    console.log("Data is null or undefined.");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        const fetchCommitHistory = async () => {
            try {
                const data: any = await getCommitHistory(program_id || "");
                console.log("Fetched Commit History data:");
                console.log(data.data);

                if (data?.data) {
                    const commitHistoryArr = data?.data;
                    setPrgHstInfo(commitHistoryArr);
                    setCurrentSeq(commitHistoryArr[0].current_seq);
                    setSelectedSeq(commitHistoryArr[0].current_seq);
                } else {
                    console.log("Data is null or undefined.");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }

            /*
                useEffect(() => {
                    console.log("parameter");
            
            
                    const prgHstData = data?.data?.data;
            
            
            
                    if (prgHstData) {
            
            
                        setPrgHstInfo(prgHstData);
                        console.log(prgHstInfo);
                        setSelectedSeq(prgHstData[0].current_seq);
                        setCurrentSeq(prgHstData[0].current_seq);
            
                    }
                }, [data]);
            */



        };


        fetchSQLAndDescription();
        fetchParameter();
        fetchCommitHistory();
    }, [program_id, trigger]);

    useEffect(() => {
        console.log("selected seq change");
        console.log(typeof (selectedSeq));
        if (typeof selectedSeq === 'number') {
            console.log("seq");
            console.log(selectedSeq);
            console.log("query");
            console.log(prgHstInfo[selectedSeq - 1]?.sql);
            setSQL(prgHstInfo[selectedSeq - 1]?.sql);
            setOriginalSQL(prgHstInfo[selectedSeq - 1]?.sql);
        }
    }, [selectedSeq]);


    const programDetailTabClick = (menu: string) => {
        if (menu === programDetailMenu) {
            return
        } else {
            setProgramDetailMenu(menu);
        }
    }

    const mergeSQLAndParameters = async () => {
        try {
            const paramString = prmInfo.map((p) => p.param_name).join(",");

            const { data } = await defaultAxios({
                method: 'post',
                //url: 'http://localhost:5000/api/request/',
                url: backendUrl,
                data: {
                    program_id: 'PERCENT-ADMIN-PRG-C-UPDPRGPRM',
                    params: {
                        'p_program_id': SQLState?.program_id.trim(),
                        'p_param_list': paramString.trim(),
                        'p_prg_description': SQLState?.prg_description.trim(),
                        'p_sql': sql.trim(),
                        'p_input_psn': userName,
                        'p_commit_msg': commitMsg.trim()
                    },
                    page_index: -1,
                },
            });

            return data;

        } catch (error) {
            console.error(error);
            return null;
        }
    }

    const onCommitClick = async () => {
        /*
        --PERCENT-ADMIN-PRG-C-CRTPRGPRM 
        WITH val AS (
            SELECT
                $1::text as p_program_id, 
                $2::text as p_param_list, 
                $3::text as p_prg_description, 
                $4::text as p_sql, 
                $5::text as p_input_psn, 
                $6::text as p_commit_msg,
                $7::text as p_parent_code
        )
        select insert_frm_prg_prm(v.p_program_id, v.p_param_list, v.p_prg_description, v.p_sql, p_input_psn, v.p_commit_msg, V.p_parent_code) 
        from val v;
        */

        if (!SQLState?.program_id.trim()) {
            alert("Please enter PROGRAM_ID");
            return;
        }

        if (!sql.trim()) {
            alert("Please enter SQL");
            return;
        }

        if (!commitMsg.trim()) {
            alert("Please enter commit message");
            return;
        }

        try {
            const result = await mergeSQLAndParameters();

            if (result && result.ok === true) {
                alert("Commit complete");
                refreshProgramDetailPage();
                //alert("Merge successful!"); // You can customize this alert message
                // Refresh the page with program_id
                //window.location.href = `/your-program-detail-path?program_id=${SQLState.program_id}`;
            } else {
                //alert("Merge failed. Please check the logs for details.");
            }
        } catch (error) {
            console.error("Error merging SQL and parameters:", error);
            alert("An error occurred while merging. Please check the logs for details.");
        }
    }

    const onWindowCloseClick = () => {
        navigate(-1);
    }

    const handleCopyClick = () => {
        try {
            navigator.clipboard.writeText(program_id ? program_id : "");
        } catch (error) {
            alert('클립보드 복사에 실패하였습니다.');
        }
    };

    const generateCommitMessage = async () => {
        try {
            console.log(`${backendUrl}open-ai/gen-commit-msg/`);
            const { data } = await defaultAxios({
                method: 'post',
                url: `${backendUrl}open-ai/gen-commit-msg/`,
                //url: backendUrl,
                data: {
                    'before_code': originalSQL,
                    'after_code': sql
                },
            });

            setCommitMsg(data.commit_message);

        } catch (error) {
            console.error(error);
            return null;
        }
    }

    return (
        <div className="flex flex-1  min-h-screen bg-gray-800 px-4 py-12 flex-col">
            <div
                className="flex flex-row bg-gray-700 pl-4 items-center space-x-4 overflow-hidden rounded-t-lg"
            >
                <div className="flex flex-col flex-1 my-2">
                    <div className="flex flex-row items-center space-x-2">
                        <span className="text-menu py-2">{program_id}</span>
                        <FaLink className="text-white cursor-pointer" onClick={handleCopyClick} />
                    </div>
                    <div className="flex justify-end  items-center">
                        <div className="w-12 pr-2 mr-2">
                            <TbBrandOpenai className="text-white cursor-pointer w-full h-full opacity-100 hover:opacity-80" onClick={generateCommitMessage} />
                        </div>

                        <input
                            className="appearance-none border-none block w-full rounded bg-slate-400 bg-opacity-50 p-2 leading-tight outline-none text-white focus:bg-opacity-100 transition-all duration-300 mr-4" id="nick" type="text" placeholder="Enter commit message..."
                            value={commitMsg}
                            onChange={(e) => { setCommitMsg(e.target.value) }}
                        />
                        <div className="m-2">
                            <button className="group relative h-10 w-40 overflow-hidden rounded-2xl bg-cyan-500 text-lg font-bold text-white" onClick={onCommitClick}>
                                Commit
                                <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                            </button>
                        </div>
                        <div className="m-2">
                            <button className="group relative h-10 w-40 overflow-hidden rounded-2xl bg-amber-500 text-lg font-bold text-white">
                                Delete
                                <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    className="flex items-center flex-shrink-0 p-0 m-0 h-full cursor-pointer bg-gray-600" onClick={onWindowCloseClick}
                >
                    < AiFillCloseCircle className="text-white w-10" />
                </div>
            </div>
            <div className="flex flex-row h-full bg-[#2B2D30] border-gray-500 border-t">
                <div className="flex flex-col w-3/5">
                    <span className={`${curretnSeq === selectedSeq ? "bg-black" : "bg-zinc-600"} text-white bg-opacity-70 italic  px-4 py-2 border-b border-gray-500 text-sm`}>
                        {curretnSeq === selectedSeq ? '.SQL (Current version)' : '.SQL(Version ' + selectedSeq + ')'}
                    </span>
                    <div className="flex-1 overflow-auto">
                        <CodeEditor
                            value={sql}
                            language="sql" // Change the language to PostgreSQL
                            placeholder="Please enter SQL code."
                            onChange={(event) => setSQL(event.target.value)}
                            padding={15}
                            style={{
                                backgroundColor: "#2B2D30", // Darker background for better contrast
                                color: "#B9BBBF", // White text
                                fontFamily: 'Fira Code, monospace',
                                fontSize: '14px', // Increase font size for readability
                                border: 'none', // Remove the border
                                overflowY: 'auto', // Enable vertical scrolling
                                //height: '100%', // Full height for the editor
                                width: '100%'
                            }}
                        />
                    </div>
                    <textarea
                        className="flex w-full h-2/5 p-4 bg-black text-body border-none resize-none focus:outline-none"
                        style={{ whiteSpace: 'pre-line' }}
                        value={testResult}
                    />
                </div>
                <div className="flex flex-col w-2/5 bg-gray-900">


                    <div className=" bg-gray-700 border-gray-700  px-4 w-full">
                        <ul className="flex items-center gap-2 text-sm font-medium">
                            {curretnSeq === selectedSeq ?
                                <li className="flex-1 cursor-pointer px-6" onClick={() => programDetailTabClick(PARAMETER)}>
                                    <span
                                        className={` relative flex items-center justify-center gap-2 px-3 py-2 border-b-2  ${programDetailMenu === PARAMETER ? " border-b-white  text-white " : "border-b-transparent text-gray-400 hover:border-b-2 hover:border-b-gray-400 hover:text-gray-400 "}`}
                                    >
                                        Parameter
                                    </span>
                                </li>
                                : null
                            }
                            <li className="flex-1 cursor-pointer px-6" onClick={() => programDetailTabClick(DESCRIPTION)}>
                                <span
                                    className={` relative flex items-center justify-center gap-2 px-3 py-2 border-b-2  ${programDetailMenu === DESCRIPTION ? " border-b-white  text-white " : "border-b-transparent text-gray-400 hover:border-b-2 hover:border-b-gray-400 hover:text-gray-400 "}`}
                                >
                                    Description
                                </span>
                            </li>
                            <li className="flex-1 cursor-pointer px-6" onClick={() => programDetailTabClick(HISTORY)}>
                                <span
                                    className={` relative flex items-center justify-center gap-2 px-3 py-2 border-b-2  ${programDetailMenu === HISTORY ? " border-b-white  text-white " : "border-b-transparent text-gray-400 hover:border-b-2 hover:border-b-gray-400 hover:text-gray-400 "}`}
                                >
                                    History
                                </span>
                            </li>
                            {curretnSeq === selectedSeq ?
                                <li className="flex-1 cursor-pointer px-6" onClick={() => programDetailTabClick(TEST)}>
                                    <span
                                        className={` relative flex items-center justify-center gap-2 px-3 py-2 border-b-2  ${programDetailMenu === TEST ? " border-b-white  text-white " : "border-b-transparent text-gray-400 hover:border-b-2 hover:border-b-gray-400 hover:text-gray-400 "}`}
                                    >
                                        Test
                                    </span>
                                </li> : null
                            }


                        </ul>
                    </div>

                    {programDetailMenu === DESCRIPTION ? <ProgramDescriptionTab program_id={program_id ? program_id : ""} programDescription={SQLState} setProgramDescription={setSQLState} /> : null}
                    {programDetailMenu === PARAMETER ? <ParameterTab prmInfo={prmInfo} setPrmInfo={setPrmInfo} /> : null}
                    {programDetailMenu === HISTORY ? <CommitHistoryTab prgHstInfo={prgHstInfo} setPrgHstInfo={setPrgHstInfo} selectedSeq={selectedSeq} setSelectedSeq={setSelectedSeq} curretnSeq={curretnSeq} setCurrentSeq={setCurrentSeq} refreshProgramDetailPage={refreshProgramDetailPage} /> : null}
                    {programDetailMenu === TEST ? <TestTab program_id={program_id ? program_id : ""} prmInfo={prmInfo} setPrmInfo={setPrmInfo} setTestResult={setTestResult} /> : null}


                </div>
            </div>


        </div>
    );
}

export { ProgramDetailPage };